import { type Role, useAuthStore } from '@/store/auth-store';
import { Navigate, Outlet } from 'react-router-dom';

interface RoleGuardProps {
  requireRole: Role;
}

export function RoleGuard({ requireRole }: RoleGuardProps) {
  const role = useAuthStore((state) => state.role);
  if (role !== requireRole) {
    return <Navigate to="/dashboard" replace />;
  }
  return <Outlet />;
}
